<template>
  <div class=" navigation2" v-if="companyInfo">
    <div class="nav-box">
      <div class="border-img-box">
        <img
          v-if="companyInfo.exInfo"
          :src="companyInfo.exInfo.logo"
          v-load="'oLogoSmall'"
        />
        <div class="nav-info">
          <div class="nav-info-top">
            <div class="nav-info-txt">{{companyInfo.exInfo.compName || companyInfo.exInfo.shortName}}</div>
          </div>
          <div class="nav-info-bottom">
            <div class="nav-info-txt" v-if="companyInfo.exInfo.country && companyInfo.exInfo.country !='中国'">
              <van-icon name="location-o" />
              {{companyInfo.exInfo.country}}
            </div>
            <div class="nav-info-txt" v-else-if="companyInfo.exInfo.province && companyInfo.exInfo.city">
              <van-icon name="location-o" />
              {{companyInfo.exInfo.province}}
              <span v-if="companyInfo.exInfo.province && companyInfo.exInfo.city">·</span>
              {{companyInfo.exInfo.city}}
            </div>
          </div>
        </div>
        <div class="nav-btn" :class="isFollower?'love':''" @click="setCollect()">{{isFollower ? '已关注': '关注'}}</div>
      </div>
      <livePeople2 :companyInfo="companyInfo"></livePeople2>
    </div>
    <!-- <div class="nav-brand">
      <span>体育建材人气 TOP1</span>
    </div> -->
  </div>
</template>

<script>
import livePeople2 from "@/components/live-people2/index";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "navigation2",
  props:['companyInfo'],
  data() {
    return {
      isShow: false, // 授权弹框
      isFollower:false,
    };
  },
  components: {
    livePeople2,
  },
  computed: {
    ...mapGetters({
      exhibitorId:'company/getExhibitorId',
      companyId:'company/getCompanyId',
      userId:'getUserId',
      userInfo: "getUserInfo",
      exhibitionId:'getExhibitionId'
    }) 
  },
  created(){
    this.isFollower = this.companyInfo.isFollower;
  },
  methods: {
    ...mapActions({
      addCompLove:'company/addCompLove',
      delCompLove:'company/delCompLove',
      addCompView:'company/addCompView',
      getAllCompany:'company/getAllCompany',
    }),
    setCollect() {
      if(this.isFollower){ // 已关注
        this.delLove();
      } else {
         this.addLove();
      }
    },
    async addLove() {
      // 展商关注
      let userInfo = {
        nickName: this.userInfo.nickName,
        avatarUrl: this.userInfo.avatarUrl
      };
      let body = {
        compId: this.companyId,
        exhibitionId: this.exhibitionId,
        exhibitorId: this.exhibitorId,
        userId: this.userId,
        userInfo: JSON.stringify(userInfo)
      };
      let result = await this.addCompLove(body);
      if (result.result) {
        this.isFollower = true;
        this.$toast.success('已关注');
        this.$emit('add');
      } else {
        this.isFollower = false;
        this.$toast.success(result.message);
      }
    },

    async delLove() {
      // 取消关注
      let body = {
        exhibitorId: this.exhibitorId,
        userId: this.userId,
      };
      let result = await this.delCompLove(body);
      if (result.result) {
        this.isFollower = false;
        this.$toast.success('取消关注');
        this.$emit('add');
      } else {
        this.isFollower = true;
        this.$toast.success(result.message);
      }
    },
  }
};
</script>

<style scoped lang="scss">
.status-bar,
.navigation-bar,
.navigation2,
.menu {
  transition: 0.3s;
  width: 100%;
  margin-left: 0.2rem;
}
.navigation2 {
  margin-left:auto;
  .nav-box {
    display: flex;
    align-items: center;
    height: 0.64rem;
    padding: 0.2rem 0.3rem 0;
    position: relative;
  }
}

.status-bar {
  background-color: transparent;
}

.navigation-bar {
  background-color: transparent;
}

.title {
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #2c2b2b;
}

.border-img-box {
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 0.64rem;
  background-size: 100% 100%;
  display: flex;
  height: 0.64rem;
  align-items: center;
  box-sizing: border-box;
  width: 3.8rem;
  padding: 0 0.03rem;
}

.border-img-box img {
  height: 0.58rem;
  width: 0.58rem;
  border-radius: 50%;
  margin-right: 0.1rem;
  // object-fit: cover;
}

.border-img-box .txt {
  font-size: 12px;
  color: #000;
}

.nav-info {
  display: flex;
  width: 1.75rem;
  margin-right: 0.15rem;
  flex-wrap: wrap;
  align-items: stretch;
}

.nav-info-txt {
  width: calc(100% - 1px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  img {
    width: 0.14rem;
    height: 0.18rem;
  }
}

.nav-info-top {
  width: 100%;
  color: #fff;
  .nav-info-txt{
    font-size: 0.2rem;
  }
}

.nav-info-bottom {
  width: 100%;
  color: #fff;
  .nav-info-txt {
    display: flex;
    align-items: center;
    font-size: 0.18rem;
    span{
      font-size: 0.18rem;
    }
    .van-icon{
      vertical-align: text-top;
      margin-right: 2px;
    }
  }
}
.nav-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 0.4rem;
  background-color: #f85b0f;
  border-radius: 0.42rem;
  font-size: 0.24rem;
  color: #fff;
  text-align: center;
  width: 1rem;
  border: 1px solid #f85b0f;
  &.love{
    color: #f85b0f;
    background-color: transparent;
  }
}
.nav-txt {
  font-size: 0.3rem;
  color: #333;
  text-align: center;
}
.nav-brand {
  margin-top: 0.3rem;
  display: inline-block;
  background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%),
    linear-gradient(#1390f8, #1390f8);
  border-radius: 0.32rem;
  color: #fff;
  span { 
    height: 0.32rem; 
    line-height: 0.32rem; 
    font-size: 0.18rem;
    padding: 0 0.2rem; 
  }
}
</style>
